import { render, staticRenderFns } from "./ConnectorBoxFacebook.vue?vue&type=template&id=d68c502e&"
import script from "./ConnectorBoxFacebook.vue?vue&type=script&lang=js&"
export * from "./ConnectorBoxFacebook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports